/** The Adiox mark and wordmark. The gradient uses the theme's two accent colours. */
export function Mark({ className = 'h-6 w-6' }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="adiox-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--accent-2)" />
          <stop offset="1" stopColor="var(--accent)" />
        </linearGradient>
      </defs>
      <path
        d="M12 48 L32 12 L52 48 M21 36 H43"
        fill="none"
        stroke="url(#adiox-mark)"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Wordmark({ className = 'h-8' }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Mark className="h-full w-auto" />
      <span className="bg-gradient-to-r from-accent2 to-accent bg-clip-text text-2xl font-bold tracking-tight text-transparent">
        Adiox
      </span>
    </div>
  );
}
